import React from 'react';
import { useIntl } from 'umi';
import Loading from '@intelligence/components/Loading';
import './index.scss';

const NO_PERMISSION_TEXT = {
  'zh-CN': '您暂无该页面权限，请联系rexzhhu或者ivyyfchen开通',
  'en-US':
    'You do not have permission to view this page. Please contact rexzhhu@tencent.com or ivyyfchen@tencent.com to request access.',
};

interface NoPermissionNewProps {
  loading?: boolean;
  showTips?: boolean;
}

const NoPermissionNew: React.FC<NoPermissionNewProps> = ({ loading = false, showTips = true }) => {
  const { locale } = useIntl();
  let textTips = '';

  if (showTips) {
    if (locale === 'zh-CN') {
      textTips = NO_PERMISSION_TEXT['zh-CN'];
    } else {
      textTips = NO_PERMISSION_TEXT['en-US'];
    }
  }

  if (loading) return <Loading />;

  return (
    <div className="no-permission-container">
      <div className="no-permission-box">
        <div className="no-permission-img" />
        <div className="no-permission-tips">{textTips}</div>
      </div>
    </div>
  );
};

export default NoPermissionNew;
